var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay p-20"},[_c('app-icon-button',{attrs:{"id":"chat-closed-overlay","color":"#0095da","dark":""},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" Задать новый вопрос ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }